import script from "./FoilCutter3_BackSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./FoilCutter3_BackSheet.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__